<script setup lang="ts">
interface Props {
  ui?: {
    wrapper?: string
  }
}
const props = withDefaults(defineProps<Props>(), {
  ui: () => ({})
})
</script>

<template>
  <div class="flex flex-col flex-1" :class="props.ui?.wrapper">
    <slot />
  </div>
</template>
